/**
 * Vasaloppet Mina Sidor
 * Author: Peter Löfås, peter@lofas.se
 */

import React, { Fragment } from "react"
import FirebaseContext from "../../../../providers/Firebase/context";
import { ApiBackend } from "../../../../providers/apibackend";
import { Box, CardActions, Checkbox, CircularProgress, FormControlLabel, LinearProgress, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import { createStyles, Theme, WithStyles, withStyles } from "@material-ui/core/";
import CardContent from "@material-ui/core/CardContent";
import { RaceEntryOverview } from "../../../../model/RaceEntryOverview";
import ProductList from "../../../Common/ProductList/ProductList";
import { ProductListChangeEvent } from "../../../Common/ProductList/utils";
import EntryOverviewItems from "./EntryOverviewItems";

interface State {
    loading: boolean;
    race: RaceEntryOverview;
    raceId: string;
    downloadingCsv: boolean;
    showArchived: boolean;
}

class EntryOverview extends React.Component<WithStyles, State> {
    static contextType = FirebaseContext;

    private readonly api: ApiBackend;

    constructor(props: WithStyles) {
        super(props);
        this.state = { loading: true, race: null, raceId: "", downloadingCsv: false, showArchived: false };
        this.api = new ApiBackend();
    }

    componentDidMount() {
        this.setState({ loading: true });
    }

    render() {
        return <Fragment>
            <Box style={{ display: "flex", gap: 10, marginBottom: 10 }}>
                <ProductList
                    showArchived={this.state.showArchived}
                    autoSelectFirst={true}
                    productTypes={["race", "event"]}
                    onInit={async (evt: ProductListChangeEvent) => {
                        await this.loadEvent(evt.products[0]?.id);
                    }}
                    onChange={async (evt: ProductListChangeEvent) => {
                        await this.loadEvent(evt.products[0]?.id);
                    }}
                />
                <FormControlLabel
                    control={
                        <Checkbox color="primary"
                            value={this.state.showArchived}
                            onChange={(ev) => {
                                this.setState({ showArchived: ev.target.checked });
                            }}
                        />
                    }
                    label="Inkludera arkiverade" />
            </Box>

            {this.state && this.state.loading &&
                <LinearProgress variant="indeterminate" color="secondary" />
            }
            {this.state && this.state.race &&
                this.renderEntryOverview()
            }
        </Fragment>;
    }

    private renderEntryOverview = () => {
        if (!this.state || !this.state.race) {
            return null;
        }

        const { classes } = this.props;

        return (
            <Card>
                <CardHeader className={classes.cardHeader} title={<Fragment><Typography variant="h5" style={{ display: "inline" }}>Anmälningsöversikt {this.state.race.name}</Typography></Fragment>} />
                <CardContent>
                    <EntryOverviewItems
                        key={this.state.raceId}
                        raceId={this.state.raceId}
                        race={this.state.race}
                    />
                </CardContent>
                <CardActions>
                    {this.state.raceId &&
                        <Button variant="contained" color="primary" onClick={() => { this.downloadAsCsv(); }}>Ladda ner anmälningar som CSV{this.state.downloadingCsv && <CircularProgress />}</Button>
                    }
                </CardActions>
            </Card>
        );
    };

    private loadEvent = async (id: string) => {
        this.setState({ loading: true });
        const product = await this.api.getEntryOverview(id);
        this.setState({ race: product, raceId: id, loading: false });
    };

    private downloadAsCsv = async () => {
        this.setState({ downloadingCsv: true });
        await this.api.downloadEntriesAsCSV(this.state.raceId);
        this.setState({ downloadingCsv: false });
    };
}

const useStyles = ({ palette, spacing }: Theme) => createStyles({
    cardHeader: {
        background: palette.secondary.main,
        color: palette.secondary.contrastText,
        padding: 3
    },
    gridheader: {
        background: "#eee",
        padding: 10
    },
    photo: {
        height: "30px",
        verticalAlign: "middle",
        borderRadius: "10px"
    },
    root: {

    },
    form: {
        "& > *": {
            margin: spacing(1),
            width: "25ch",
        },
        "& label.Mui-focused": {
            color: palette.secondary.main,
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: palette.secondary.main,
        },
    }
});

export default withStyles(useStyles)(EntryOverview);
